module.exports = __webpack_public_path__ + "static/media/36.95ad4fe.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/36.wav
// module id = m7S6
// module chunks = 0